module.exports = __webpack_public_path__ + "img/logo_3.d6246a2b.svg";